/**
 * 配列の末尾から条件を満たす要素を削除し続けた新しい配列を返す（非破壊的）
 * @param array 対象配列
 * @param predicate 削除を続ける条件
 * @returns 条件を満たす末尾要素を削除した新しい配列
 */
export function arrayPopWhile<T>(array: T[], predicate: (item: T) => boolean): T[] {
  const copy = [...array];
  while (copy.length > 0 && predicate(copy[copy.length - 1])) {
    copy.pop();
  }
  return copy;
}
